import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=4e6f2b55&"
import script from "./Error404.vue?vue&type=script&lang=js&"
export * from "./Error404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e6f2b55')) {
      api.createRecord('4e6f2b55', component.options)
    } else {
      api.reload('4e6f2b55', component.options)
    }
    module.hot.accept("./Error404.vue?vue&type=template&id=4e6f2b55&", function () {
      api.rerender('4e6f2b55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Error404.vue"
export default component.exports